<div class="full-layout">
    <app-header>
        <a class="header-logo">
        <img class="img" src="../../../../../assets/logo/logo.svg" alt="logo"/>
        <span class="heading">Maersk Container Monitoring</span>
        <span class="beta px-2 pt-1">Beta</span>
        </a>
    </app-header>
     <app-compact-sidemenubar></app-compact-sidemenubar>
    <app-content>
        <router-outlet></router-outlet>
    </app-content>
</div>
<lib-toaster></lib-toaster>
<lib-loader></lib-loader>
